import React, { useState } from 'react';
import { FiCheck, FiX, FiUser } from 'react-icons/fi';
import { matchAPI } from '../services/api';
import logger from '../utils/logger';

const JoinRequestsManager = ({ matchId, requests, onUpdate }) => {
  const [processingId, setProcessingId] = useState(null);

  const pendingRequests = requests?.filter(r => r.status === 'pending') || [];

  if (pendingRequests.length === 0) {
    return null;
  }

  const handleAction = async (userId, action) => {
    setProcessingId(userId);
    try {
      if (action === 'approve') {
        await matchAPI.approveJoinRequest(matchId, userId);
      } else {
        await matchAPI.rejectJoinRequest(matchId, userId);
      }
      onUpdate();
    } catch (error) {
      logger.error(`Failed to ${action} request`, { error: error.message });
      alert(`Failed to ${action} request. Please try again.`);
    } finally {
      setProcessingId(null);
    }
  };

  return (
    <div className="bg-gray-900 border-l-4 border-red-500 p-8 rounded-sm mt-8">
      <h2 className="text-xl font-bold text-white mb-6">Pending Join Requests ({pendingRequests.length})</h2>
      <div className="space-y-4">
        {pendingRequests.map((req) => (
          <div key={req.user?._id || req.user} className="bg-gray-800 p-5 rounded">
            <div className="flex justify-between items-start gap-4">
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-4">
                  <div className="bg-gray-700 w-10 h-10 rounded-full flex items-center justify-center text-gray-400">
                    <FiUser size={20} />
                  </div>
                  <div>
                    <p className="text-white font-bold">{req.user?.fullName || 'Unknown User'}</p>
                    <p className="text-sm text-gray-400">{req.user?.email || ''}</p>
                  </div>
                </div>

                {req.message && (
                  <div className="mb-4 bg-gray-900 p-3 rounded text-sm text-gray-300">
                    <span className="text-gray-500 font-bold block mb-1 uppercase tracking-wider text-xs">Message:</span>
                    {req.message}
                  </div>
                )}

                {req.answers && req.answers.length > 0 && (
                  <div className="space-y-3 mt-4">
                    <span className="text-gray-500 font-bold block uppercase tracking-wider text-xs border-b border-gray-700 pb-1">Answers:</span>
                    {req.answers.map((ans, idx) => (
                      <div key={idx} className="bg-gray-900 p-3 rounded text-sm">
                        <p className="text-gray-400 mb-1 font-medium">{ans.question}</p>
                        <p className="text-white">{ans.answer || 'N/A'}</p>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div className="flex flex-col gap-2 shrink-0">
                <button
                  onClick={() => handleAction(req.user?._id || req.user, 'approve')}
                  disabled={processingId === (req.user?._id || req.user)}
                  className="flex items-center gap-2 px-4 py-2 bg-green-500/20 text-green-500 hover:bg-green-500 hover:text-white rounded font-bold transition disabled:opacity-50"
                >
                  <FiCheck /> Approve
                </button>
                <button
                  onClick={() => handleAction(req.user?._id || req.user, 'reject')}
                  disabled={processingId === (req.user?._id || req.user)}
                  className="flex items-center gap-2 px-4 py-2 bg-red-500/20 text-red-500 hover:bg-red-500 hover:text-white rounded font-bold transition disabled:opacity-50"
                >
                  <FiX /> Reject
                </button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default JoinRequestsManager;
